// components/chat/chat-input/AttachmentUploadButton.tsx
import { Paperclip, Camera } from "lucide-react";

interface UploadButtonProps {
  onFilesAdded: (files: File[]) => void;
}

export const AttachmentUploadButton = ({ onFilesAdded }: UploadButtonProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    onFilesAdded(Array.from(e.target.files));
    e.target.value = "";
  };

  return (
    <label htmlFor="chat-file-upload" className="cursor-pointer">
      <div className="mb-1 rounded-md p-2 text-primary/50 opacity-100 hover:bg-muted hover:text-primary">
        <Paperclip className="h-4 w-4 -rotate-45 flex-shrink-0" />
      </div>
      <input
        id="chat-file-upload"
        type="file"
        className="hidden"
        multiple
        accept=".pdf,.doc,.docx,.txt,.md,.csv,.ppt,.pptx,audio/*"
        onChange={handleChange}
      />
    </label>
  );
};

export const ImageUploadButton = ({ onFilesAdded }: UploadButtonProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    onFilesAdded(Array.from(e.target.files));
    e.target.value = "";
  };

  return (
    <label htmlFor="chat-image-upload" className="cursor-pointer">
      <div className="mb-1 rounded-md p-2 text-primary/50 opacity-100 hover:bg-muted hover:text-primary">
        <Camera className="h-4 w-4 flex-shrink-0" />
      </div>
      <input
        id="chat-image-upload"
        type="file"
        className="hidden"
        multiple
        accept="image/*"
        onChange={handleChange}
      />
    </label>
  );
};
